import { css, html, LitElement, nothing } from 'lit'
import { customElement } from 'lit/decorators.js'
import '../Shared/Button'
import '../Shared/Image'
import '../Shared/Video'
import { ApiBlockItemModel, HeroElementModel, VideoSettingsElementModel } from '../api/ContentDeliveryApi.schemas'
import { renderMedia } from '../RenderElement'
import { RenderButton } from '../Shared/Button'

@customElement('lindberg-hero')
export class Hero extends LitElement {
	static styles = css`
        :host{
            display: grid;
            position: relative;
            place-items:center;
            overflow: hidden;
            text-align: center;
        }
        
        @media (width >= 600px) {
            .mobile-only {
                display: none;
            }
        }

        @media (width < 600px) { 
            .desktop-only {
                display: none;
            }
        }

        div {
            position: absolute;
            z-index:10;
            width: calc(100% - 2 * var(--hero-outer-margin) - 2 * var(--hero-inner-margin));
            height: calc(100% - 2 * var(--hero-outer-margin) - 2 * var(--hero-inner-margin));
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: var(--hero-inner-margin);
        }

        :host(.left) div { align-items: flex-start; text-align: left }
        :host(.right) div { align-items: flex-end; text-align: right }
        :host(.top) div { justify-content: flex-start }
        :host(.bottom) div { justify-content: flex-end }

        h1 {
            font-size: var(--font-size-header-display);
            font-weight: var(--font-weight-light);
            text-rendering: geometricprecision;
            line-height: var(--font-line-height-header-display);
            color: light-dark(var(--color-text-base-dark), var(--color-text-base-light));
            margin: 0;
        }
        :host(.rounded-corners) {
            border-radius: var(--elements-round-corner-md);
        }
        /* :host {
            border-radius: 10px;
            @supports (corner-shape: squircle) {
                border-radius: 15px;
                corner-shape: superellipse(1.2);
            }
        }         */
    `

	data!: { content: HeroElementModel; settings: VideoSettingsElementModel }

	render() {
		this.data.settings?.properties.contentAlign?.split(' ').forEach(x => this.classList.add(x))
		if (this.data.settings?.properties.colorScheme) this.style.setProperty('color-scheme', this.data.settings.properties.colorScheme)            
        this.classList.toggle('rounded-corners', this.data.settings?.properties?.roundedCorners === true)

		return html`
            ${this.data.content.properties.title || this.data.content.properties.link ? html`<div>
                ${this.data.content.properties.title ? html`<h1>${this.data.content.properties.title}</h1>` : nothing}
                ${this.data.content.properties.link ? RenderButton(this.data.content.properties.link) : nothing}
            </div>` : nothing}
			${this.data.content.properties?.media ? renderMedia(this.data.content.properties.media, this.data.settings, this.data.content.properties?.mobileMedia) : nothing}
        `
	}
}
